const SYMBOLS = [
  ['-9px', '25%', '-0.3s'],
  ['18%', '-5px', '-1.6s'],
  ['72%', '-5px', '-0.9s'],
  ['calc(100% + 9px)', '24%', '-2.1s'],
  ['calc(100% + 10px)', '78%', '-1.2s'],
  ['80%', 'calc(100% + 5px)', '-0.5s'],
  ['30%', 'calc(100% + 5px)', '-2.4s'],
  ['-10px', '80%', '-1.8s'],
];

const RepairButtonAura = () => (
  <span className="coreboundRepairAura" aria-hidden="true">
    {SYMBOLS.map(([left, top, animationDelay], index) => (
      <i key={index} style={{ left, top, animationDelay }}>
        +
      </i>
    ))}
  </span>
);

export default RepairButtonAura;
